export default __webpack_public_path__ + "static/media/logo-text.942b6afa.svg";